import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconLoop(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6.35249 6.3524C4.72279 7.98407 3.78296 10.2964 4.04291 12.839C4.41285 16.5128 7.3923 19.5359 11.0616 19.9463C15.9107 20.4968 20 16.743 20 12.0082C20 8.81492 18.1303 6.07212 15.4408 4.79081C14.771 4.47048 14.0011 4.95097 14.0011 5.69173C14.0011 6.06211 14.2011 6.41246 14.531 6.57263C16.9606 7.70378 18.5003 10.4166 17.8404 13.3796C17.3505 15.6018 15.5408 17.3937 13.3212 17.8642C9.44193 18.705 6.00256 15.752 6.00256 12.0082C6.00256 10.3465 6.69243 8.86497 7.78223 7.78386L9.29196 9.29541C9.92184 9.92605 11.0016 9.4856 11.0016 8.59469V5.00102C11.0016 4.45046 10.5517 4 10.0018 4L6.41248 4C5.52264 4 5.07273 5.0811 5.70261 5.71175L6.35249 6.3524Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
